import React from 'react';
import { Button, Icon } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useMutation } from '../../../../graphql/hooks';
import { CREATE_SECTION, GET_SECTIONS } from '../../graphql';
import { SectionCreateMutationResult } from './types';

const CreateSectionButton = () => {
    const [create] = useMutation<SectionCreateMutationResult>(
        CREATE_SECTION, { refetchQueries: [{ query: GET_SECTIONS }] });
    const handleSectionCreation = async () => create();
    const { t } = useTranslation();
    return (
        <Button
            startIcon={<Icon>add</Icon>}
            variant="outlined"
            color="primary"
            size='large'
            onClick={handleSectionCreation}
        >
            {t('Add section')}
        </Button>
    );
};

export default CreateSectionButton;
